package dev.lingvo.site.components.studio.editor

/** One owned frame coalesces pointer traffic; tests inject a deterministic request/cancel pair. */
internal class FrameScheduler(
    private val requestFrame: (() -> Unit) -> Int,
    private val cancelFrame: (Int) -> Unit,
    private val draw: () -> Unit,
) {
    private var pending: Int? = null
    private var disposed = false
    fun request() {
        if (disposed || pending != null) return
        pending = requestFrame { pending = null; if (!disposed) draw() }
    }
    fun flushFrame() {
        val id = pending ?: return
        cancelFrame(id)
        pending = null
        if (!disposed) draw()
    }
    fun dispose() {
        disposed = true
        pending?.let(cancelFrame)
        pending = null
    }
}
